import round from "lodash.round";

export function getHumanPrice(priceAsInteger: number, currency?: string, withoutCurrency?: true): number;
export function getHumanPrice(
  priceAsInteger: number | null | undefined,
  currency?: string,
  withoutCurrency?: false,
): string;

export function getHumanPrice(
  priceAsInteger: number | null | undefined,
  currency = "PLN",
  withoutCurrency = false,
): string | number {
  if (typeof priceAsInteger !== "number") {
    return "";
  }

  if (withoutCurrency) {
    return round(priceAsInteger / 100, 2);
  }

  return `${round(priceAsInteger / 100, 2).toFixed(2)} ${currency.toUpperCase()}`;
}
